import React from "react";
import { Outlet, Link as RouterLink } from "react-router-dom";
import { Box, Container, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CopyrightNotice } from "../components/common/CopyrightNotice";
import { openCookieSettings } from "../utils/cookie-consent";
import { useHasCookieConsent } from "../hooks/useHasCookieConsent";

const AuthLayout: React.FC = () => {
  const { t } = useTranslation("common");
  const hasCookieConsent = useHasCookieConsent();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: (theme) => theme.palette.background.default,
      }}
    >
      <Container component="main" maxWidth="lg" sx={{ flexGrow: 1, py: 8 }}>
        <Outlet />
      </Container>

      <Box
        component="footer"
        sx={{
          py: 3,
          textAlign: "center",
          backgroundColor: (theme) => theme.palette.background.paper,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {t("auth.footerTagline")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <Link
            component={RouterLink}
            to="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            color="inherit"
            underline="hover"
          >
            {t("auth.privacyPolicy")}
          </Link>
          {" | "}
          <Link
            component={RouterLink}
            to="/terms-of-service"
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            color="inherit"
            underline="hover"
          >
            {t("auth.termsOfUse")}
          </Link>
          {" | "}
          <Link
            component="button"
            variant="body2"
            color="inherit"
            underline="hover"
            onClick={openCookieSettings}
            sx={{ cursor: "pointer", background: "none", border: "none" }}
          >
            {t("auth.doNotSell")}
          </Link>
          {hasCookieConsent && (
            <>
              {" | "}
              <Link
                component="button"
                variant="body2"
                color="inherit"
                underline="hover"
                onClick={openCookieSettings}
                sx={{ cursor: "pointer", background: "none", border: "none" }}
              >
                {t("auth.cookieSettings")}
              </Link>
            </>
          )}
        </Typography>
        <CopyrightNotice />
      </Box>
    </Box>
  );
};

export default AuthLayout;
